import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import React from "react";
import styles from "./styles.module.css";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "@tanstack/react-query";
import { useResponsive } from "../../../../hooks/customUseResponsive";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { removeHtmlTagsAndEntities } from "../../../../hooks/removehtmlTags";
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import AddNoticeSchema from "../../../../schemas/addNotice";
import RHFTextField from "../../../../components/RFH/RFHtextfield";
import { addNotice } from "../../../../services/notice/apiAddNotice";

export default function AddNoticeModal({ openProp, handleClose, refetch }) {
  const isMobile = useResponsive("down", "sm");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? 330 : 808,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    scrollY: "scroll",
  };
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      [{ color: [] }, { background: [] }],
      ["link"],
      ["clean"],
    ],
  };
  const defaultValues = {
    policy_name: "",
    description: "",
  };

  const methods = useForm({
    resolver: yupResolver(AddNoticeSchema),
    defaultValues,
  });

  const { mutate, isPending } = useMutation({
    mutationFn: addNotice,
    onSuccess: (data) => {
      toast.success(data.data.message);
      methods.reset();
      refetch();
      handleClose();
    },
    onError: (data) => {
      console.error("error adding notice", data);
    },
  });

  // console.log("errors === ", methods.formState.errors);

  const onSubmit = (formData) => {
    // console.log("formData === ", formData);
    mutate(formData);
  };

  return (
    <Modal open={openProp} onClose={handleClose}>
      <Box sx={{ ...style }}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Stack direction="row" className={styles.header}>
              <Typography className={styles.heading}>Add Notice</Typography>
              <Box onClick={() => handleClose()}>
                <CloseIcon className={styles.icon} />
              </Box>
            </Stack>

            <Box className={styles.container}>
              <Stack className={styles.contSelect}>
                <Box className={styles.flexItem}>
                  <Typography className={styles.label}>Notice Name</Typography>
                  <RHFTextField
                    name="policy_name"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: isMobile
                          ? "30px !important"
                          : "40px !important",
                        backgroundColor: "#fff",
                        fontSize: isMobile ? "12px !important" : "",
                      },
                    }}
                  />
                </Box>
              </Stack>
              <Typography className={styles.label}>Description</Typography>
              <Box className={styles.textEditorCont}>
                <ReactQuill
                  value={methods.getValues("description")}
                  onChange={(value) =>
                    methods.setValue(
                      "description",
                      removeHtmlTagsAndEntities(value).length === 0 ? "" : value
                    )
                  }
                  modules={modules}
                  style={{ height: "170px" }}
                />
              </Box>
              <Typography className={styles.feedbackError}>
                {methods.formState.errors.description?.message}
              </Typography>
              <Stack className={styles.btnCont}>
                <LoadingButton
                  loading={isPending}
                  type="submit"
                  className={styles.btnClass}
                  variant="contained"
                  color="primary"
                >
                  Submit
                </LoadingButton>

                <Button
                  className={styles.btnClass}
                  onClick={() => handleClose()}
                  variant="outlined"
                  color="primary"
                >
                  Close
                </Button>
              </Stack>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </Modal>
  );
}
